import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/* Scroll-management on every route change.
   - No hash → snap to top.
   - With hash → poll up to ~1.2s (chunk + lazy section may not be in
     the DOM yet on first render) and scroll the target into view
     (e.g. /partner#partner-stack-banner). */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      return;
    }
    const id = hash.slice(1);
    let tries = 0;
    let timer;
    const tick = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      tries += 1;
      if (tries < 24) timer = setTimeout(tick, 50); // ~1.2s total
    };
    // Defer past the initial render so lazily-mounted sections exist.
    timer = setTimeout(tick, 50);
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [pathname, hash]);
  return null;
}
